import { en } from '@x7web/tcom-ui'
import merge from 'lodash-es/merge'

export default merge({}, en, {
  pagination: {
    total: 'Total {total} data'
  }
})
